import { useEffect, useState } from "react";

const TeacherDashboard = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const [students, setStudents] = useState([]);
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    // mock data (replace with API later)
    setStudents([
      { id: 1, name: "Rahul", course: "React" },
      { id: 2, name: "Priya", course: "UI/UX" },
    ]);

    setCourses([
      { id: 1, title: "React Course" },
      { id: 2, title: "Node Course" },
    ]);
  }, []);

  return (
    <div>
      <h2>Welcome, {user?.name} 👨‍🏫</h2>

      <div className="stats-grid">
        <div className="card">👨‍🎓 Students: {students.length}</div>
        <div className="card">📚 Courses: {courses.length}</div>
      </div>
    </div>
  );
};

export default TeacherDashboard;